import { VariantAttribute } from "@swo/shared";
import { PDPInternalState } from "./types";
import { selectVariantForAttributesState } from "./select-variant-for-attributes-state";

export function onAttributeClicked(state: PDPInternalState, clickedAttribute: VariantAttribute): PDPInternalState {
  return {
    selectedProduct: state.selectedProduct,
    multiselectsForProduct: state.multiselectsForProduct,
    variantSelectionMethod: "user-picked",
    ...onAttributeClickedUpdate(state, clickedAttribute),
  };
}

export function onAttributeClickedUpdate(state: PDPInternalState, clickedAttribute: VariantAttribute) {
  const inActionAttributeModificationIndex = getInActionAttributeModificationIndex(state, clickedAttribute);

  const afterActionUpdatedAttributesSelection = getAttributesSelectionUpdatedAfterAction(
    inActionAttributeModificationIndex,
    state.attributesSelection,
    clickedAttribute,
  );

  return selectVariantForAttributesState(
    state.selectedProduct,
    afterActionUpdatedAttributesSelection,
    inActionAttributeModificationIndex,
  );
}

export function getInActionAttributeModificationIndex(state: PDPInternalState, clickedAttribute: VariantAttribute) {
  return (state.multiselectsForProduct || []).findIndex(m => m.name === clickedAttribute.name);
}

export function getAttributesSelectionUpdatedAfterAction(
  inActionAttributeModificationIndex: number,
  attributesSelection: PDPInternalState["attributesSelection"],
  clickedAttribute: VariantAttribute,
) {
  return replaceAtIdx(attributesSelection, inActionAttributeModificationIndex, clickedAttribute);
}

function replaceAtIdx<T>(array: Array<T>, idx: number, t: T) {
  const before = array.slice(0, idx);
  const after = array.slice(idx + 1);

  return [...before, t, ...after];
}
